import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { ApiEnvNames, API_STATUS, ERROR_RESPONSE } from '../../../model/api.model';
import { LAYOUT_TYPE, OptionsFetchConfig } from '../../../model/common.model';
import { RegistrationTitle, EventTabSchema, EventDynamicOptionSchema, EventTabIds } from '../../../model/event-registration.model';
import { FieldTypesForOptions } from '../../../model/form-fields.model';
import { TabConfig, FormFieldConfig, FieldOption, Props } from '../../../model/form.model';
import { CommonService } from '../../../services/common.service';
import { CommonUtils } from '../../../utils/common.utils';
@Component({
  selector: 'app-event-tab-main',
  standalone: true,
  imports: [CommonModule, PageContainerComponent],
  templateUrl: './event-tab-main.component.html',
  styleUrl: './event-tab-main.component.scss'
})
export class EventTabMainComponent implements OnInit {
  @Input() event!: any;
  @Input() backFuncCall!: () => void;
  breadcrumbProps: any = {
    subtitle: '',
    backClicked: () => this.backFuncCall?.()
  };
  title: string = RegistrationTitle;
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  tabConfig: Array<TabConfig> = EventTabSchema;
  tabProps: Props = { isTabStretch: false };
  public isLoading = false;
  private readonly commonUtils = inject(CommonUtils)
  private readonly service = inject(CommonService);
  ngOnInit() {
    if (!this.event?.event_id) {
      console.info('Event ID is missing');
      return;
    }
    this.injectEventIdToSchemas();
    this.initializeLayout();
    this.initializeTabSubjects();
  }

  private initializeTabSubjects(): void {
    this.tabConfig.forEach((tab: any) => {
      tab['tabOnChangeSubject'] = new Subject();
      tab['tabOnChangeSubject'].subscribe(() => {
        tab.inputs?.gridSchema?.forEach((grid: any) => {
          if (grid.inputs?.DataTableSchema) {
            grid.inputs.DataTableSchema.inputFilter = '';
          }
        });
      });
    });
  }
  async initializeLayout() {
    this.isLoading = true;
    try {
      await this.fetchAndUpdateOptions();
    } finally {
      this.isLoading = false;
    }
  }

  eventDynamicOptionFields: OptionsFetchConfig = EventDynamicOptionSchema;
  fetchAndUpdateOptions = async () => {
    try {
      const response = await this.service.getDataFromDataSource(this.eventDynamicOptionFields.searchConfig, ApiEnvNames['EventDashboard'])
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          this.fillValuesFromApi(response.result[0]);
        }
      } else {
        this.commonUtils.showMatSnackBar(ERROR_RESPONSE['errorFetch'])
      }
    } catch (err) {
      console.info('Layout Error:- ', err);
    }
  };
  injectEventIdToSchemas() {
    if (this.eventDynamicOptionFields.searchConfig.body) {
      this.eventDynamicOptionFields.searchConfig.body.eventId = this.event?.event_id;
    } else {
      this.eventDynamicOptionFields.searchConfig.body = { eventId: this.event?.event_id };
    }

    this.tabConfig.forEach((tab: any) => {
      if (tab.inputs?.gridSchema) {
        tab.inputs.gridSchema.forEach((grid: any) => {
          if (grid.inputs?.apiConfig) {
            if (grid.inputs.apiConfig.body) {
              grid.inputs.apiConfig.body.eventId = this.event?.event_id;
            } else {
              grid.inputs.apiConfig.body = { eventId: this.event?.event_id };
            }
          }
        });
      }
      if (tab.inputs?.searchConfig) {
        if (tab.inputs.searchConfig.body) {
          tab.inputs.searchConfig.body.eventId = this.event?.event_id;
        } else {
          tab.inputs.searchConfig.body = { eventId: this.event?.event_id };
        }
      }
      tab.inputs ||= {};
      tab.inputs.eventId = this.event?.event_id;
    });
  }

  fillValuesFromApi = (response: any) => {
    const result: Record<string, Array<FieldOption>> = {};
    const fieldNames = new Set(this.eventDynamicOptionFields.fields.map(p => p.name));
    const dropdownData = response;
    if (dropdownData) {
      if (dropdownData['createdOn']) {
        const createdOnDate = dropdownData['createdOn'];
        this.title = this.event['event_description'];
        this.breadcrumbProps.subtitle = `( Updated dt: ${createdOnDate} )`;
      }
      Object.keys(dropdownData).forEach(fieldName => {
        result[fieldName] ??= [];
        if (dropdownData[fieldName] && Array.isArray(dropdownData[fieldName]) && dropdownData[fieldName].length > 0) {
          result[fieldName] = dropdownData[fieldName].map((item: string) => ({ 'fieldLabel': item, 'fieldValue': item }))
        } else {
          result[fieldName] = [];
        }

      })
    }
    const updateOptions = (filterSchema: FormFieldConfig[], _options: any) => {
      if (filterSchema) {
        filterSchema.forEach(field => {
          if (FieldTypesForOptions.includes(field['fieldType']) && fieldNames.has(field['fieldName'])) {
            field['options'] = result[field['fieldName']]
            field['isLoading'] = false
          }
        })
      }
    }
    this.tabConfig.forEach(tab => {
      if (tab['tabId'] === EventTabIds['Dashboard']) {
        const gridSchema = tab.inputs.gridSchema;
        if (gridSchema) {
          gridSchema.forEach(gridElm => {
            if (gridElm.inputs.filterSchema) {
              updateOptions(gridElm.inputs.filterSchema.FieldsArray, result)
            }
          })
        }
      } else if (tab['inputs']['filterSchema']) {
        updateOptions(tab.inputs.filterSchema.FieldsArray, result)
      }
    })
  }
}

